import { call, put, takeLatest } from "redux-saga/effects";
import { updateExitRowRequest, updateExitRowSuccess, updateExitRowFailure } from "../../slice/checkin/exitRow/updateExitRowSlice";
import api from "../../../../config/api";
import { config } from "../../../../config/global";
import i18n from "../../../../i18n";
const fetchUpdateExitRowData = async updateExitRow => {
  const UPDATE_EXITROW_API_URL = config.DAPI_UPDATE_EXIT_ROW;
  const data = {
    mode: "no-cors",
    headers: {
      "Accept-Language": `${i18n.language}`,
      "Content-Type": "application/json"
    },
    loader: true,
    isGenericErr: true,
    isBadRequestExceptional: false
  };
  const response = await api.post(`${UPDATE_EXITROW_API_URL}`, updateExitRow, data);
  return response;
};
function* getUpdateExitRowData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchUpdateExitRowData, payload);
    yield put(updateExitRowSuccess(response.data));
  } catch (error) {
    yield put(updateExitRowFailure(error));
  }
}
export function* watchUpdateExitRowData() {
  yield takeLatest(updateExitRowRequest.type, getUpdateExitRowData);
}